import { FileText } from "lucide-react"
import type { ComponentProps, ReactNode } from "react"

/**
 * A document-style link: icon, truncated label, optional trailing content
 * (a kind badge, a status check). Shared by OrderDocumentList's document
 * rows and OrderStatusLink so both read as the same kind of link.
 */
export const DocumentLinkButton = ({
  label,
  trailing,
  ...props
}: {
  label: string
  trailing?: ReactNode
} & ComponentProps<"button">) => (
  <button
    type="button"
    className="flex w-full items-center gap-2 rounded-sm text-left text-sm text-base-primary hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50"
    {...props}
  >
    <FileText
      className="h-3.5 w-3.5 shrink-0 text-muted-foreground"
      aria-hidden
    />
    <span className="min-w-0 truncate">{label}</span>
    {trailing}
  </button>
)

export default DocumentLinkButton
